import custom from "@/custom/customConfig.json";
import { App } from "vue";

const customConfigModules = import.meta.glob<Record<string, unknown>>(
  "@/custom/*CustomConfig.json",
  { eager: true, import: "default" }
);

const getProjectCustomConfig = (projectName: string) => {
  const matchedEntry = Object.entries(customConfigModules).find(([key]) =>
    key.endsWith(`/src/custom/${projectName}CustomConfig.json`)
  );
  return matchedEntry?.[1] || {};
};

const customConfig = {
  install(app: App) {
    const projectName = import.meta.env.VUE_APP_PROJECT_NAME;
    const projectConfig = getProjectCustomConfig(projectName);

    app.config.globalProperties.$customConfig = {
      ...custom,
      ...projectConfig,
    };

    app.provide("custom", app.config.globalProperties.$customConfig);
  },
};
export default customConfig;
